import {
  Box,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import AutoComleteFilter from 'components/AutoCompleteFilter';
import { OrangeButton } from 'components/Button';
import InputField from 'components/InputField';
import {
  CASABLANCA,
  FILTERS,
  UNIVERSES,
  FILTERS_BY_UNIVERSE,
} from 'components/MapFilter/constants';
import messages from 'components/MapFilter/messages';
import SelectInputField from 'components/SelectInputField';
import { LocationResponse } from 'containers/ServicesPage/types';
import { FormikProps, withFormik } from 'formik';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCities } from 'store/geolocAgent/actions';
import {
  getCitiesSelector,
  getIsLoadingCitiesSelector,
} from 'store/geolocAgent/selectors';
import { getLocations } from 'store/global/actions';
import {
  getLocationsSelector,
  getLocationFilterSelector,
} from 'store/global/selectors';

const MapFilter = (
  props: {
    getCities: Function;
    getLocations: Function;
    filterWith: string;
    cities: any;
    locations: LocationResponse[];
    isLoadingCities: boolean;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const filterTypes = values.universe
    ? FILTERS_BY_UNIVERSE[values.universe]
    : Object.keys(FILTERS);
  return (
    <form onSubmit={handleSubmit}>
      <Box py={4}>
        <Grid container spacing={2}>
          <Grid item xs={matches ? 12 : 8}>
            <InputField
              placeholder={translate(get(messages, 'research'), props)}
              name="research"
              value={values.research}
              handleChange={handleChange}
              handleBlur={handleBlur}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </Grid>
          {!matches && (
            <Grid item xs={matches ? 12 : 4}>
              <OrangeButton type="submit" variant="contained">
                {translate(get(messages, 'research'), props)}
              </OrangeButton>
            </Grid>
          )}
          <Grid item xs={matches ? 12 : 4}>
            <SelectInputField
              label={translate(get(messages, 'universe'), props)}
              name="universe"
              onChange={handleChange}
              value={values.universe}
              data={UNIVERSES()}
              handleBlur={handleBlur}
              Children={UNIVERSES()
                .filter((ele) => {
                  return ele.isVisible;
                })
                .map((item: any) => (
                  <MenuItem value={item.value} key={item.label}>
                    {translate(get(messages, item.label), props)}
                  </MenuItem>
                ))}
            />
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <SelectInputField
              label={translate(get(messages, 'filterWith'), props)}
              name="filterWith"
              onChange={handleChange}
              value={values.filterWith}
              data={UNIVERSES()}
              handleBlur={handleBlur}
              Children={filterTypes.map((item: any) => (
                //@ts-ignore
                <MenuItem value={FILTERS[item]} key={item}>
                  {translate(get(messages, item), props)}
                </MenuItem>
              ))}
            />
          </Grid>
          <Grid item xs={matches ? 12 : 4}>
            <AutoComleteFilter
              label={translate(get(messages, 'city'), props)}
              placeholder={translate(get(messages, 'city'), props)}
              name="city"
              value={values.city}
              options={Array.from(props.cities)}
              isLoading={props.isLoadingCities}
              setFieldValue={setFieldValue}
              getItems={props.getCities}
            />
          </Grid>
          {matches && (
            <Grid item xs={matches ? 12 : 4}>
              <OrangeButton type="submit" variant="contained">
                {translate(get(messages, 'research'), props)}
              </OrangeButton>
            </Grid>
          )}
        </Grid>
      </Box>
    </form>
  );
};

interface FormValues {
  research: string;
  universe: string;
  filterWith: string;
  city: {
    lat?: number;
    lon?: number;
    name?: string;
  };
}

export interface FormProps {
  intl: IntlShape;
  isLoadingCities: boolean;
  cities: any;
  locations: LocationResponse[];
  getCities: Function;
  getLocations: Function;
  setCenter: Function;
  filterWith: string;
}

const EnhancedMapFilter = withFormik<FormProps, FormValues>({
  mapPropsToValues: (props) => {
    return {
      research: '',
      universe: '',
      filterWith: props.filterWith,
      city: CASABLANCA,
    };
  },
  handleSubmit: async (values, { props }) => {
    const {
      city: { lat, lon },
    } = values;

    /* istanbul ignore next */
    GATracking.event(
      EVENT_CATEGORIES.SERVICES,
      EVENT_ACTION.CLICK,
      'Rechercher',
    );

    props.getLocations({
      filterWith: values.filterWith,
      research: values.research,
      latitude: lat,
      longitude: lon,
    });
    props.setCenter({ lat: values.city.lat!, lng: values.city.lon! });
  },
})(MapFilter);

const mapStateToProps = createStructuredSelector<
  any,
  {
    isLoadingCities: boolean;
    cities: any;
    locations: LocationResponse[];
    filterWith: string;
  }
>({
  isLoadingCities: getIsLoadingCitiesSelector,
  cities: getCitiesSelector,
  locations: getLocationsSelector,
  filterWith: getLocationFilterSelector,
});

const mapDispatchToProps = {
  getCities,
  getLocations,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EnhancedMapFilter));
